module.exports = __webpack_public_path__ + "img/shenron.6d17aec5.png";